//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class StandardFormStatus {
    static readonly InProgress: string = "InProgress";
    static readonly Submitting: string = "Submitting";
    static readonly Submitted: string = "Submitted";
    static readonly Returned: string = "Returned";
    static readonly Closed: string = "Closed";
    static readonly Rejected: string = "Rejected";
    static readonly Deleted: string = "Deleted";
    static readonly __PURGED__: string = "__Purged__";
    static AllStatuses: string[] = ["InProgress","Submitting","Submitted","Returned","Closed","Rejected","Deleted"];
    static ForcedStatuses: string[] = ["Closed","Rejected","Deleted"];
    static PendingStatuses: string[] = ["InProgress","Submitting","Returned"];
    static StatusLabels: { [key: string]: string; } = {"InProgress":"Unsubmitted","Submitting":"Submitting","Submitted":"Submitted","Returned":"Returned","Closed":"Closed","Rejected":"Rejected","Deleted":"Deleted"};
}
